import { TFunction } from 'i18next';
import { ProductStatusTypes } from '../../../common/enums';
import { MerchantAccountStatus } from '../enums';
import { resources } from '../resources/resources';

export const productStatusColor: { [key in ProductStatusTypes]: string } = {
  [ProductStatusTypes.Archived]: '#f5f5f5',
  [ProductStatusTypes.Active]: '#d9ecb8',
  [ProductStatusTypes.Draft]: '#ffebc5',
  [ProductStatusTypes.PendingApproval]: '#e0ecff',
  [ProductStatusTypes.Rejected]: '#ffd0c9',
  [ProductStatusTypes.PendingDeactivation]: '#ffeeed',
};

export const getProductStatusInfo = (
  status: ProductStatusTypes,
  translate: TFunction,
): string => {
  switch (status) {
    case ProductStatusTypes.Archived:
      return translate(resources.status.info.archived);
    case ProductStatusTypes.Active:
      return translate(resources.status.info.active);
    case ProductStatusTypes.Draft:
      return translate(resources.status.info.draft);
    case ProductStatusTypes.PendingApproval:
      return translate(resources.status.info.pendingApproval);
    case ProductStatusTypes.Rejected:
      return translate(resources.status.info.rejected);
    case ProductStatusTypes.PendingDeactivation:
      return translate(resources.status.info.pendingDeactivation);
  }
};

export const accountStatusColor: { [key in MerchantAccountStatus]: string } = {
  [MerchantAccountStatus.PendingEmailConfirmation]: '#681d96',
  [MerchantAccountStatus.Active]: '#d9ecb8',
  [MerchantAccountStatus.Inactive]: '#f5f5f5',
};

export const localStorageKeys = {
  productSentForReview: 'productSentForReview',
  accountInvitationSent: 'accountInvitationSent',
};

export const lowStockThreshold = 10;

export const emailRegex =
  /^[a-zA-Z0-9+._%-]{1,256}@[a-zA-Z0-9][a-zA-Z0-9-]{0,64}(\.[a-zA-Z0-9][a-zA-Z0-9-]{0,25})+$/;
export const onlyDigitsRegex = /^[0-9]+$/;
